import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userStatus',
})
export class UserStatusPipe implements PipeTransform {
  transform(value: unknown): unknown {
    switch (value) {
      case false:
        return 'Blocked';
      case true:
        return 'Active';
      default:
        return '';
    }
  }
}
